import { PricingModel, Product, ServiceStatusInfo } from '../types';
import { isEmpty } from 'lodash';
import { isProductActiveOrInProgress } from './getProductButtonConfig';
import { isNonSelfServeProductCode } from './productCodes';

interface CanModifyProductProps {
  isProductInCart: boolean;
  isPoolTenant: boolean;
  product: Product;
  crsEnableSelfServe: boolean;
  currentServiceStatusInfo?: ServiceStatusInfo;
  requiredPricingModel: PricingModel;
  checkTiers: boolean;
}

export const canModifyProduct = ({
  isProductInCart,
  isPoolTenant,
  product,
  crsEnableSelfServe,
  currentServiceStatusInfo,
  requiredPricingModel,
  checkTiers,
}: CanModifyProductProps): boolean => {
  if (isPoolTenant) return false;
  if (!crsEnableSelfServe) return false;
  if (isProductInCart) return false;
  if (!product.quantifiable) return false;

  if (product.pricingData?.pricingModel !== requiredPricingModel) {
    return false;
  }

  if (checkTiers && product.pricingData.priceDetails?.tiers?.length === 0) {
    return false;
  }

  if (isNonSelfServeProductCode(product.code)) return false;
  if (isProductActiveOrInProgress(currentServiceStatusInfo)) return false;

  return true;
};
